const getCookie = (name: string): string | null => {
  const match = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${name}=`));
  return match ? match.split("=")[1] : null;
};

// Return true if the webview query param exists on the URL, a hidden element exists, or the cookie is set
export const getIsWebView = (): boolean => {
  const hasQueryParam = new URLSearchParams(document.location.search).has(
    "webview",
  );
  const hasHiddenElement = document.getElementById("webview") !== null;
  const hasCookie = getCookie("in_app_webview") === "1";

  return hasQueryParam || hasHiddenElement || hasCookie;
};
